import React from "react";
import ReactDOM from "react-dom/client";

// Estilos
import "./index.css";

// Componente principal
import App from "./App";

// Contexto de turnos
import { BookingProvider } from "./contexts/BookingContext";

// Service Worker
import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BookingProvider>
			<App />
		</BookingProvider>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
